// Studio Kees: add set items (matching pillow for a dog bed, extra bowls for a bowl) together with the main product in one cart request.
const keesState = (window.__keesSet ??= {});

// State per product + variant, so checkboxes survive Prestige re-rendering the product info
const keesKey = (el, box) => `${el.dataset.productId}:${box.value}`;
const keesDefine = (tag) => {
  if (customElements.get(tag)) return;
  customElements.define(tag, class extends HTMLElement {
    connectedCallback() {
      this.restore();
      this.addEventListener('change', (e) => {
        if (e.target.matches('.kees-set__check')) keesState[keesKey(this, e.target)] = e.target.checked;
      });
    }
    restore() {
      this.querySelectorAll('.kees-set__check').forEach((box) => { if (keesState[keesKey(this, box)]) box.checked = true; });
    }
  });
};
keesDefine('kees-set-pillow');
keesDefine('kees-set-bowl');

// Prestige morphs the product info on a size change, which can reset the checkbox
const keesRestoreAll = () => document.querySelectorAll('kees-set-pillow, kees-set-bowl').forEach((el) => el.restore?.());
document.addEventListener('variant:change', () => { keesRestoreAll(); setTimeout(keesRestoreAll, 300); setTimeout(keesRestoreAll, 1000); });

// All checked set items that belong to this product form
const keesFindChecked = (form) => {
  for (const el of document.querySelectorAll('kees-set-pillow, kees-set-bowl')) {
    const host = el.closest('[observe-form]');
    if (!host || host.getAttribute('observe-form') === form.getAttribute('id')) {
      return Array.from(el.querySelectorAll('.kees-set__check:checked'));
    }
  }
  return [];
};

if (!window.__keesSetBound) {
  window.__keesSetBound = true;

  document.addEventListener('submit', async (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.matches('form[action*="/cart/add"]')) return;
    const boxes = keesFindChecked(form);
    if (!boxes.length) return;

    // Take over from the theme product-form handler for this submit only
    event.preventDefault();
    event.stopImmediatePropagation();

    const buttons = Array.from(form.elements).filter((el) => el.type === 'submit')
      .concat(Array.from(document.querySelectorAll(`button[type="submit"][form="${CSS.escape(form.getAttribute('id') || '')}"]`)));
    if (buttons.some((b) => b.getAttribute('aria-busy') === 'true')) return;
    buttons.forEach((b) => b.setAttribute('aria-busy', 'true'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:start', { bubbles: true }));

    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:prepare-bundled-sections', { bubbles: true, detail: { sections } }));

    const fd = new FormData(form);
    const main = { id: Number(fd.get('id') || form.elements.namedItem('id')?.value), quantity: Number(fd.get('quantity') || 1) };
    const properties = {};
    for (const [k, v] of fd.entries()) {
      const m = k.match(/^properties\[(.+)\]$/);
      if (m && v !== '') properties[m[1]] = v;
    }
    if (Object.keys(properties).length) main.properties = properties;
    if (fd.get('selling_plan')) main.selling_plan = Number(fd.get('selling_plan'));

    let response, json;
    try {
      response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ items: [main, ...boxes.map((b) => ({ id: Number(b.value), quantity: 1 }))], sections: sections.join(',') })
      });
      json = await response.json();
    } catch (e) {
      response = { ok: false }; json = { description: 'Error' };
    }

    buttons.forEach((b) => b.removeAttribute('aria-busy'));
    document.documentElement.dispatchEvent(new CustomEvent('theme:loading:end', { bubbles: true }));

    if (!response.ok) {
      form.dispatchEvent(new CustomEvent('cart:error', { bubbles: true, detail: { error: json.description } }));
      document.dispatchEvent(new CustomEvent('cart:refresh'));
      return;
    }

    if (window.themeVariables?.settings?.cartType === 'page') {
      window.location.href = `${Shopify.routes.root}cart`;
      return;
    }

    const cart = await (await fetch(`${Shopify.routes.root}cart.js`)).json();
    cart.sections = json.sections;
    const onSuccessDo = fd.get('on_success');
    form.dispatchEvent(new CustomEvent('variant:add', { bubbles: true, detail: { items: json.items ?? [json], cart, onSuccessDo } }));
    document.documentElement.dispatchEvent(new CustomEvent('cart:change', { bubbles: true, detail: { baseEvent: 'variant:add', onSuccessDo, cart } }));
  }, true);
}
